import QRCode from 'qrcode';

export const generateQrDataUrl = async (payload) => {
  const text = String(payload || '').trim();
  if (!text) {
    throw new Error('QR payload is empty');
  }
  return QRCode.toDataURL(text, {
    width: 480,
    margin: 2,
    color: { dark: '#0b0b0b', light: '#ffffff' },
    errorCorrectionLevel: 'M',
  });
};

export const pickProfileField = (obj, ...keys) => {
  for (const key of keys) {
    const val = obj?.[key];
    if (val != null && String(val).trim() !== '') return String(val).trim();
  }
  return '';
};

export const copyTextToClipboard = async (text) => {
  const value = String(text || '').trim();
  if (!value) return false;
  await navigator.clipboard.writeText(value);
  return true;
};
